import React from 'react';

import { Translator } from 'ggApp/modules/translator';

import CopyBox from './CopyBox';
import { Wrap, Text } from './styled';

type FeedbackBannerProps = {
    className?: string;
    text?: string;
    textTK?: string;
    copyableText?: string;
    onCopied?: () => void;
    tkValues?: Record<string, string>;
};

const FeedbackBanner = ({
    className,
    text,
    textTK,
    copyableText,
    onCopied,
    tkValues,
}: FeedbackBannerProps) => {
    return (
        <Wrap className={className}>
            {!!text && <Text>{text}</Text>}
            {!!textTK && <Translator tk={textTK} withValues={tkValues} />}
            {!!copyableText && <CopyBox textToCopy={copyableText} onCopied={onCopied} />}
        </Wrap>
    );
};

export default FeedbackBanner;
